import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { url } from '../../js/api/endpoint';
import language from '../../js/stores/language.js';
import themes from '../../js/stores/theme.js';
import user from '../../js/stores/user.js';
import file from '../../js/stores/file.js';
import carLoanItemLibrary from '../../js/controllers/car-loan-item-lib.js';
import googleMaps from '../../js/controllers/google-map-lib.js';
import CarFeaturesReadOnly from './components/features-read-only.f7.html';
import '../../css/car-display.css';
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var carId = user.getters.carId.value;
  var carItem = props;
  var isLogged = user.getters.isLogged.value;
  var isOwner = user.getters.carId.value == props.CarMainData.CarId ? true : false;
  var isBorrower = user.getters.carId.value != props.CarMainData.CarId ? true : false;
  var carImageListPhotos = [];
  var carImageListBrowser;
  var extraSetup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return googleMaps.initLocationMap('car-location', carItem.CarMainData.ContactLocalityName, 'Netherlands');
          case 1:
            $update();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function extraSetup() {
      return _ref2.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var carListFiles, i, urlFile;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return file.dispatch('getCarImageList', carItem.CarMainData.CarId);
        case 1:
          carListFiles = _context2.sent;
          carImageListPhotos = [];
          for (i = 0; i < carListFiles.length; i++) {
            if (!(carListFiles[i].FilePath.length == 0 && carListFiles[i].FileName.length == 0)) {
              urlFile = "".concat(url, "/").concat(carListFiles[i].FilePath, "/").concat(carListFiles[i].FileName);
              carImageListPhotos.push(urlFile);
            }
          }
          if (carImageListPhotos.length > 0) {
            carImageListBrowser = $f7.photoBrowser.create({
              photos: carImageListPhotos,
              theme: themes.getters.Name.value
            });
          }
          if (process.env.ENVIROMENT !== "dev") {
            setTimeout(function () {
              extraSetup();
            }, 250);
          }
          $update();
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var goLendCar = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            try {
              $f7.views.main.router.navigate('/loan-item/0', emptyCarLoan());
            } catch (err) {
              console.error(err);
            }
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function goLendCar() {
      return _ref4.apply(this, arguments);
    };
  }();
  var openStandaloneDark = function openStandaloneDark() {
    carImageListBrowser.open();
  };
  var emptyCarLoan = function emptyCarLoan() {
    var obj = {
      props: {}
    };
    obj.props = carItem;
    obj.props.CarFeatureList = props.CarFeatureList;
    obj.props.CarUseRestrictionList = props.CarUseRestrictionList;
    obj.props.CarPenaltyUseList = props.CarPenaltyUseList;
    obj.props.CarLoanData = {
      CarLoanId: 0,
      BorrowerId: 0,
      CarPricePerDay: 0,
      DaysToBorrow: 0,
      TotalToPay: 0,
      Discounts: 0,
      IsGoingAbroad: 0,
      CarLoanStartDate: null,
      CarLoanEndDate: null,
      CarLoanStartTime: null,
      CarLoanEndTime: null,
      CarLoanStatusId: 0,
      InvoiceId: 0,
      CurrentKilometers: 0,
      CurrentFuelLevel: 0,
      ReturningKilometers: 0,
      ReturningFuelLevel: 0,
      CarLicensePlate: '',
      CarLoanTag: "DLA-LN-00000000",
      ExtraDriverContactId: 0,
      AppointmentDate: null,
      AppointmentPlace: '',
      ReturnAppointmentDate: null,
      ReturnAppointmentPlace: '',
      RealCarLoanStartDate: null,
      RealCarLoanEndDate: null
    };
    obj.props.ExtraDriverData = {
      ContactId: 0,
      ContactName: '',
      ContactFirstLastName: '',
      ContactSex: 0,
      ContactBirthDate: null,
      ContactAddress: '',
      ContactAddressStreet: '',
      ContactAddressExteriorNumber: '',
      ContactDistrict: '',
      ContactZipcode: '',
      ContactCellphone: '',
      ContactLocalityName: ''
    };
    obj.props.AppointmentData = {
      CarAppointmentId: 0,
      CarAppointmentDate: null,
      CarAppointmentAddress: '',
      CarAppointmentLatitude: 0.00,
      CarAppointmentLongitude: 0.00
    };
    obj.props.ReturnAppointmentData = {
      CarAppointmentId: 0,
      CarAppointmentDate: null,
      CarAppointmentAddress: '',
      CarAppointmentLatitude: 0.00,
      CarAppointmentLongitude: 0.00
    };
    return obj;
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="car-display">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('general.details')}</div>
    </div>
  </div>
  <!-- Show lend button only to borrower-->
  ${isLogged && isBorrower && $h`
  <div id="go-to-lend-car" class="fab fab-right-top color-blue">
    <a href="#" @click="${goLendCar}">
      <i class="material-symbols-outlined">car_tag</i>
    </a>
  </div>
  `}
  <div class="page-content">
    <div class="prev">
      <div class="left-side sub-item hidden-xs-down">
      </div>
      <div class="center-side sub-item">
        <div class="block-title">${carItem.CarMainData.CarManufacturerName} ${carItem.CarMainData.CarModel} ${carItem.CarMainData.CarYear} <br />
        </div>
        <div class="block">
          <div class="grid grid-cols-1 grid-gap">
            <div><img class="" src="${url}/${carItem.CarMainData.FilePath}/${carItem.CarMainData.FileName}" /></div>
          </div>
          <div class="block-title">${locale.translate('car.edit.carFeatureLabel')}</div>
          <${CarFeaturesReadOnly} list=${props.CarFeatureList} />
          <div class="block-title">${locale.translate('car.edit.carUseRestrictionLabel')}</div>
          <${CarFeaturesReadOnly} list=${props.CarUseRestrictionList} />
          <div class="block-title">${locale.translate('car.edit.penaltiesForMisusing')}</div>
          <${CarFeaturesReadOnly} list=${props.CarPenaltyUseList} />
        </div>
        <div class="block list">
          <p class="grid grid-cols-3 xlarge-grid-cols-3">
            <div></div>
            <div>
              <a class="button button-small button-fill color-lime ${carImageListPhotos.length < 1  && $h`disabled`}" @click=${openStandaloneDark}>
                <span class="material-symbols-outlined">image</span>${locale.translate('car.edit.carImagesPhotoBrowserLabel')}
              </a>
            </div>
            <div></div>
          </p>
        </div>
        <div class="block stack-content">
          <div class="sub-item">
            <div style="width: 100%;height: 400px;">
              <p style="font-weight: bold;">${locale.translate('home.main.location')}: ${locale.translate('user.edit.location.currenteOwnerLocationLabel')}: ${carItem.CarMainData.ContactLocalityName}, Netherlands</p>
              <div id="car-location-map"></div>
            </div>
          </div>
          <div class="sub-item">
            <div class="card">
              <div class="card-header">${locale.translate('car.dashboard.aboutLender')}: ${locale.translate('general.owner')}</div>
              <div class="card-content">
                <div class="list media-list no-safe-areas">
                  <ul>
                    <li class="item-content">
                      <div class="item-media"><img src="${carItem.CarMainData.ownerAvatarPicture}" width="64" />
                      </div>
                      <div class="item-inner">
                        <div class="item-title-row">
                          <div class="item-title">${carItem.CarMainData.ContactName}</div>
                        </div>
                        <div class="item-subtitle">
                          <div style="white-space: wrap !important;">${carItem.CarMainData.CarOwnerDescription}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-footer">
                <span><i class="icon material-symbols-outlined color-lime">star</i>4.8</span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-side sub-item hidden-xs-down">
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'fbd813c3bd';
export default framework7Component;